import React, { useContext, useState } from "react";
import { Outlet } from "react-router-dom";
import ClientSidebar from "components/Sidebar/ClientSidebar.js";
import PrivateRoute from "components/PrivateRoute";
import styled, { createGlobalStyle } from "styled-components";
import { AppContext } from "contexts/AppContext";

const GlobalStyle = createGlobalStyle`
`;

const SidebarWrapper = styled.div`
  width: 250px;
  top: 0 !important;
  height: 100vh;
  max-height: 100vh;

  @media (max-width: 768px) {
    position: fixed;
    z-index: 1000;
  }
`;

export const Layout = () => {
  const [sidebarWidth, setSidebarWidth] = useState(250);
  const { theme } = useContext(AppContext);

  /*useEffect(() => {
    const html = document.documentElement;
    html.setAttribute("data-aw-theme", theme);
  }, [theme]);*/

  return (
    <PrivateRoute>
      <GlobalStyle />
      <div data-aw-theme={theme} style={{ display: "flex", flexDirection: "row", backgroundColor: "var(--page-bg)" }}>
        <SidebarWrapper style={{ width: `${sidebarWidth}px` }}>
          <ClientSidebar
            onClosed={(closed) => {
              console.log("!!! CLOSED", closed);
              if (closed) {
                setSidebarWidth(10);
              } else {
                setSidebarWidth(250);
              }
            }}
          />
        </SidebarWrapper>
        <div
          style={{
            marginTop: "20px",
            marginLeft: "20px",
            marginRight: "20px",
            width: `calc(100% - ${sidebarWidth + 40}px)`,
            position: "relative",
            zIndex: 1,
            borderRadius: "8px",
            /*height: "2000px",*/
          }}
        >
          <Outlet />
        </div>
      </div>
    </PrivateRoute>
  );
};

export default Layout;
